import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { useAuthorityCustomerQuery } from "@/api/query-hooks";

export function ClientIdentity({
  clientId,
  compact = false,
  link = true
}: {
  clientId?: number;
  compact?: boolean;
  link?: boolean;
}) {
  const { t } = useTranslation("registrationRequests");
  const query = useAuthorityCustomerQuery(clientId ?? 0);

  if (!clientId) return <span>—</span>;

  const name = query.data?.name ?? `#${clientId}`;
  const content = compact ? (
    <span className="truncate" title={query.data ? t("clientNumber", { number: query.data.number }) : name}>{name}</span>
  ) : (
    <span className="block min-w-0">
      <span className="block truncate font-medium">{name}</span>
      {query.data ? <span className="block text-xs text-muted-foreground">{t("clientNumber", { number: query.data.number })}</span> : null}
    </span>
  );

  if (!link) return <span data-testid="client-identity">{content}</span>;
  return (
    <Link
      to="/clients/$clientId"
      params={{ clientId: String(clientId) }}
      search={{ fromQ: undefined, fromClientId: undefined, fromView: undefined }}
      className={compact ? "inline-flex min-w-0 hover:text-primary hover:underline" : "block min-w-0 hover:text-primary hover:underline"}
      data-testid="client-identity"
    >
      {content}
    </Link>
  );
}
